import * as React from 'react'

import { Theme }               from '@material-ui/core'
import ListItem                from '@material-ui/core/ListItem'
import ListItemIcon            from '@material-ui/core/ListItemIcon/ListItemIcon'
import ListItemText            from '@material-ui/core/ListItemText/ListItemText'
import { withStyles }          from '@material-ui/core/styles'
import { FormattedMessage }    from 'react-intl'
import { RouteComponentProps } from 'react-router-dom'

import { SubRouting } from '../types'
import { pick }       from '../utils/index'
import DrawerList     from './DrawerList'

import testingHooks from '../testing-hooks'

interface Props extends RouteComponentProps<{}> {
  subrouting: SubRouting
  parent: {
    name: string,
    icon: any,
  }
  classes: any
  onParentClick: () => void
  onRouteSelect: () => void
}

const styles = (theme: Theme) => ({
  parent: theme.mixins.toolbar,
})

export default withStyles(styles)(
  ({ match, subrouting, parent, classes, onParentClick, onRouteSelect }: Props) => (
    <>
      <ListItem
        onClick={onParentClick}
        button
        divider
        className={classes.parent}
        data-test-id={testingHooks.sidebarMenuTitleItem}
      >
        <ListItemIcon>
          {parent.icon}
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id={'routing.' + parent.name}/>
        </ListItemText>
      </ListItem>
      <DrawerList
        onSelect={onRouteSelect}
        prefix={match.url}
        routes={subrouting.map(route => pick(
          route,
          [ 'name', 'path' ],
        ))}
      />
    </>
  ),
)



// WEBPACK FOOTER //
// ./src/routing/SidebarMenu.tsx